<div class="n-list-component-header">
    <h2>Upload contacts</h2>
    <button matIconButton matTooltip="Here comes the info"><mat-icon>info</mat-icon></button>
</div>

<form [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <p>The input file must be in Excel (.xlsx) format and follow a strict structure:

    </p>
    <ul>
        <li>A variable number of header rows to be skipped (defaults to 1)</li>
        <li>Columns 1-7 contain the following information for contacts</li>
        <ol>
            <li>First name (required)</li>
            <li>Last name (required)</li>
            <li>Email (required)</li>
            <li>Position (optional)</li>
            <li>Organisation (optional)</li>
            <li>Stakeholder groups as a comma-separated list of values (optional)</li>
            <li>Topics of interest as a comma-separated list of values (optional)</li>
        </ol>
    </ul>

    <fieldset style="margin-top:25px" class="chip-theme-filename">
        <legend>Select a file to upload</legend>
        <div
            style="display: flex; gap: 10px; align-items: center; margin-top: 10px; border: solid 0px; padding: 10px; border-radius: var(--nexus-border-radius); ">
            <button matFab extended type="button" color="primary" (click)="fileInput.click()">
                <mat-icon>search</mat-icon>
                Browse
            </button>
            <input type="file" accept=".xlsx" #fileInput (change)="onFileSelected($event)" style="display: none">

            @if (uploadFile) {
            <mat-chip (removed)="clearFile()">
                <i matChipAvatar class="fas fa-file-excel"></i>
                {{ uploadFile.name }}
                <button matChipRemove aria-label="Remove file">
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-chip>
            }
        </div>
        <div
            style="display: flex; gap: 10px; align-items: center; margin-top: 10px; padding: 10px; border-radius: var(--nexus-border-radius); ">
            <mat-form-field appearance="outline">
                <mat-label>Number of header rows</mat-label>
                <input matInput type="number" formControlName="headerRows" />
                <mat-error>Invalid number</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" [style.width.px]="350">
                <mat-label>Batch name</mat-label>
                <input matInput formControlName="batchName" />
                <mat-hint>Give a name to this upload</mat-hint>
                <mat-error>Invalid name</mat-error>
            </mat-form-field>
        </div>

    </fieldset>

    <fieldset style="margin-top:25px">
        <legend>Projects and events associations</legend>
        <div style="display: flex; flex-direction: column; gap: 10px;">
            <app-advanced-select #projectsSelect formControlName="projects" [resetTrigger]="resetCounter"
                class="n-search-field n-filter-flex-unit" label="Projects" [options]="allProjectOptions()"
                [showAllOrAny]="showAllOrAny()"
                hint="Optionnally, select project(s) to which contacts should be associated." />
            <app-advanced-select #eventsSelect formControlName="events" [resetTrigger]="resetCounter"
                class="n-search-field n-filter-flex-unit" label="Events" [options]="allEventOptions()"
                [showAllOrAny]="showAllOrAny()"
                hint="Optionnally, select events(s) to which contacts should be associated." />
        </div>
    </fieldset>

    <div class="n-button-row">
        <button mat-raised-button color="accent" type="submit" [disabled]="!uploadFile">
            Upload
        </button>
    </div>

</form>